import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { TDutiesProps } from './types';

export const Duties: FC<TDutiesProps> = ({ nameOfDuty, duty, paymentCurrency }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				gap: 4,
				ml: 4,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					gap: 1,
				}}
			>
				<Typography variant="body2" color="text.secondary">
					{nameOfDuty}
				</Typography>
			</Box>
			<AmountAndCurrency amount={duty ?? 0} currency={paymentCurrency} size={0.8} />
		</Box>
	);
};
